import React from 'react';
import './ModeToggle.css';

/**
 * ModeToggle - Support/Therapy mode switcher
 *
 * Props:
 *   mode: 'support' | 'therapeutic'
 *   onChange: (newMode) => void
 *   compact: boolean - if true, hide description (for mobile)
 */
function ModeToggle({ mode, onChange, compact = false }) {
    return (
        <div className={`mode-toggle ${compact ? 'compact' : ''}`}>
            <div className="mode-buttons">
                <button
                    className={`mode-btn ${mode === 'support' ? 'active' : ''}`}
                    onClick={() => onChange('support')}
                >
                    Support
                </button>
                <button
                    className={`mode-btn ${mode === 'therapeutic' ? 'active' : ''}`}
                    onClick={() => onChange('therapeutic')}
                >
                    Therapy
                </button>
            </div>
            {!compact && (
                <div className="mode-description">
                    {mode === 'support' ? (
                        <span>Recommended gentle, long-term support.</span>
                    ) : (
                        <span className="therapy-warning">
                            Stronger correction protocol. Higher doses. Use under medical guidance.
                        </span>
                    )}
                </div>
            )}
        </div>
    );
}

export default ModeToggle;
